function base() {
	initMenu();
	initLanguageSwitcher();
	// initPreviousReports();
	// initTooltips();
	// initRevealOnScrollAnimations();
	// initCookies();
	initBreadcrumbs();
}
